import { render, staticRenderFns } from "./FormVideoItem.vue?vue&type=template&id=77dff7e1"
import script from "./FormVideoItem.vue?vue&type=script&lang=js"
export * from "./FormVideoItem.vue?vue&type=script&lang=js"
import style0 from "./FormVideoItem.vue?vue&type=style&index=0&id=77dff7e1&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77dff7e1')) {
      api.createRecord('77dff7e1', component.options)
    } else {
      api.reload('77dff7e1', component.options)
    }
    module.hot.accept("./FormVideoItem.vue?vue&type=template&id=77dff7e1", function () {
      api.rerender('77dff7e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonPage/components/tableComp/formItems/FormVideoItem.vue"
export default component.exports